import { IAction } from "../../../interface/action.interface";
import { IUserPrefrencesDto } from "../interface/dto/user-preferences.dto";

export enum UserPreferencesActionTypes {
    USERPREFERENCES_INIT = "USERPREFERENCES_INIT",
    USERPREFERENCES_GET = "USERPREFERENCES_GET",
    USERPREFERENCES_GET_SUCCESS = "USERPREFERENCES_GET_SUCCESS",
    USERPREFERENCES_GET_ERROR = "USERPREFERENCES_GET_ERROR",
    USERPREFERENCES_UPDATE_ERROR = "USERPREFERENCES_UPDATE_ERROR",
    USERPREFERENCES_UPDATE_SUCCESS = "USERPREFERENCES_UPDATE_SUCCESS",
    USERPREFERENCES_UPDATE = "USERPREFERENCES_UPDATE",
}

export interface IInitUserPreferencesAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_INIT;
}

export const initUserPreferencesAction = () => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_INIT,
});

export interface IUserPreferencesGetSuccessAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_GET_SUCCESS;
    payload: IUserPrefrencesDto;
}

export interface IUserPreferencesGetErrorAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_GET_ERROR;
    payload: { error: string };
}

export interface IUserPreferencesGetAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_GET;
}

export interface IUserPreferencesUpdateSuccessAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE_SUCCESS;
}

export interface IUserPreferencesUpdateErrorAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE_ERROR;
    payload: { error: string };
}

export interface IUserPreferencesUpdateAction extends IAction {
    type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE;
    payload: {
        data: IUserPrefrencesDto;
    };
}

export const userPreferencesGetAction = (): IUserPreferencesGetAction => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_GET,
    payload: {},
});

export const userPreferncesGetSuccessAction = (
    data: IUserPrefrencesDto,
): IUserPreferencesGetSuccessAction => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_GET_SUCCESS,
    payload: data,
});

export const userPreferencesGetErrorAction = (
    error: string,
): IUserPreferencesGetErrorAction => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_GET_ERROR,
    payload: { error },
});

export const userPreferncesUpdateSuccessAction =
    (): IUserPreferencesUpdateSuccessAction => ({
        type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE_SUCCESS,
        payload: {},
    });

export const userPreferencesUpdateErrorAction = (
    error: string,
): IUserPreferencesUpdateErrorAction => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE_ERROR,
    payload: { error },
});

export const userPreferencesUpdateAction = (
    data: IUserPrefrencesDto,
): IUserPreferencesUpdateAction => ({
    type: UserPreferencesActionTypes.USERPREFERENCES_UPDATE,
    payload: {
        data,
    },
});

export type IUserPreferencesActions =
    | IInitUserPreferencesAction
    | IUserPreferencesGetAction
    | IUserPreferencesGetSuccessAction
    | IUserPreferencesGetErrorAction
    | IUserPreferencesUpdateSuccessAction
    | IUserPreferencesUpdateErrorAction
    | IUserPreferencesUpdateAction;
